
<div class="order-rate">
<div class="close-btn-outer" *ngIf="data?.showSkip">
  <button [disabled]="skipingRate">
    <a class="mx-2" (click)="skip()" >
      <app-loading *ngIf="skipingRate"></app-loading>
      {{"orders.skip" | translate}}
    </a>
  </button>
 
</div>
<div class="close-btn-outer" *ngIf="data?.showExit">
  <a class="mx-3" (click)="close()">
    <!-- <app-loading *ngIf="skipingRate"></app-loading> -->
    <!-- {{"orders.skip" | translate}} -->
    X
  </a>
</div>

<div mat-dialog-content style=" overflow: visible !important;">
  <form (submit)="submitRate()" [formGroup]="rateForm" novalidate>
      <p class="order-rate-header mb-0">{{"orders.howWasYourExperience"| translate}} </p>
       <p class="order-rate-header">{{"wallet.OrderId" | translate }} :  {{data?.orderId}}</p>

       <div *ngIf="environmentVariables.ENABLE_ORDER_RATE_WITH_PRODUCT">
         <div class="" formArrayName="items">
           <div *ngFor="let item of formItems; let i = index" [formGroupName]="i">
             <div class="d-flex item-product">
               <img  [src]="item.value.image" width="50px">
               <span>{{item.value.name}}</span>
             </div>
               <bar-rating [max]="5" formControlName="rate" [rate]="data?.driver_rate" [readOnly]="data?.isDisableRate"></bar-rating>
           </div>
         </div>
       </div>
      <div>
        <span style="color: black;">{{"orders.rateOrder" | translate}}</span>
        <bar-rating [max]="5" formControlName="rate" [rate]="data?.rate" [readOnly]="data?.isDisableRate"></bar-rating>
        <div *ngIf="rateForm.controls.rate.invalid && (rateForm.controls.rate.dirty || rateForm.controls.rate.touched)"
            class="alert alert-danger">
            <div *ngIf="rateForm.controls.rate.errors?.required" style="color: #d32f2f" translate>
                {{'orders.rateOrderRequired' | translate}}
            </div>
        </div>
       </div>
      <span style="color: black;">{{"orders.rateDriver" | translate}}</span>
      <bar-rating [max]="5" formControlName="driver_rate" [rate]="data?.driver_rate" [readOnly]="data?.isDisableRate"></bar-rating>
      <div *ngIf="rateForm.controls.driver_rate.invalid && (rateForm.controls.driver_rate.dirty || rateForm.controls.driver_rate.touched)"
          class="alert alert-danger">
          <div *ngIf="rateForm.controls.driver_rate.errors?.required" style="color: #d32f2f" translate>
              {{'orders.rateDriverRequired' | translate}}

          </div>
      </div>


      <mat-form-field appearance="fill"  class="example-full-width" style="margin-top:8px; width: 100% ; direction: ltr;">
          <!-- <mat-label >{{"orders.writeYourFeedback" | translate}}</mat-label> -->
          <textarea matInput maxlength="500" [readonly]="data?.isDisableRate" formControlName="feedback" name="notes" 
              placeholder='{{"orders.writeYourFeedback" | translate}}' style="height: 60px; text-align: right; resize: none;"></textarea>
      </mat-form-field>
      <button 
         *ngIf="!data?.isDisableRate"
          mat-raised-button color="primary"  
          class="submit-btn"
          translate
          [disabled]="submittingRate"
          >
          <app-loading *ngIf="submittingRate"></app-loading>
          {{"input_text.submit" | translate}}
        </button>
  </form>
</div>
</div>
